module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO ORIGINAL GOOGLE-04f2b6f2b22e68c92529d9565035b9af.png";